import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IAdminRole } from 'src/models/admin.model';
import style from './role-maintenance-list.module.scss';
import RoleMaintenanceAdd from '../role-maintenance-add/role-maintenance-add.component';
import RoleMaintenanceEdit from '../role-maintenance-edit/role-maintenance-edit.component';
import RoleMaintenanceDelete from '../role-maintenance-delete/role-maintenance-delete.component';

type IProp = {
  data: IAdminRole[];
  loading: boolean;
};

const RoleMaintenanceView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<IAdminRole>[] = [
    {
      title: Lang.LBL_EMPLOYEE_NUM,
      index: 'empNo',
      width: '25%',
    },
    {
      title: Lang.LBL_EMPLOYEE_NAME,
      index: 'empName',
      render: (_, value) => (
        <span>{`${value.lastName}, ${value.firstName}`}</span>
      ),
      width: '30%',
    },
    {
      title: Lang.LBL_ROLE,
      index: 'role',
      render: (_, value) => <span>{`${value.Role.name}`}</span>,
      width: '30%',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <RoleMaintenanceEdit data={value} />
          <RoleMaintenanceDelete data={value} />
        </>
      ),
      width: '15%',
    },
  ];
  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[1].render) {
      customColumns[1].render(
        true,
        { firstName: 'cebu', lastName: 'yas' } as IAdminRole,
        1,
        {} as any
      );
    }
    if (customColumns[2].render) {
      customColumns[2].render(
        true,
        { Role: { name: 'admin' } } as IAdminRole,
        1,
        {} as any
      );
    }
    if (customColumns[3].render) {
      customColumns[3].render(true, {} as IAdminRole, 1, {} as any);
    }
  }
  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_ADMIN_ROLE_MAINTENANCE} />
        <RoleMaintenanceAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default RoleMaintenanceView;
